import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface UserInfo {
    firstName: string;
    lastName: string;
    email: string;
}

export interface SignUpState {
    activeStep: number;
    signUpId: string;
    userInfo: UserInfo;
}

function extractStateFromSessionStorage(): SignUpState {
    const stateFromStorage = sessionStorage.getItem('customer-signup-form')

    return stateFromStorage ? JSON.parse(stateFromStorage) : {
        activeStep: 0,
        signUpId: '',
        userInfo: {
            firstName: '',
            lastName: '',
            email: '',
        },
    };
}

export const signUpSlice = createSlice({
    name: 'signUp',
    initialState: extractStateFromSessionStorage(),
    selectors: {
        activeStepSelector: (state) => state.activeStep,
        userInfoSelector: (state) => {
            return {
                ...state.userInfo,
                signUpId: state.signUpId
            };
        }
    },
    reducers: {
        setActiveStep: (state, action : PayloadAction<number>) => {
            state.activeStep = action.payload;
            sessionStorage.setItem('customer-signup-form', JSON.stringify(state));
        },
        setUserInfo: (state, action: PayloadAction<UserInfo>) => {
            state.userInfo.firstName = action.payload.firstName;
            state.userInfo.lastName = action.payload.lastName;
            state.userInfo.email = action.payload.email;
            sessionStorage.setItem('customer-signup-form', JSON.stringify(state));
        },
        setSignUpId: (state, action: PayloadAction<string>) => {
            state.signUpId = action.payload;
            sessionStorage.setItem('customer-signup-form', JSON.stringify(state));
        },
        clearState: (state) => {
            state.activeStep = 0;
            state.signUpId = '';
            state.userInfo = {
                firstName: '',
                lastName: '',
                email: '',
            };
            sessionStorage.removeItem('customer-signup-form');
        }
    }
});

export const { 
    setActiveStep,
    setUserInfo, 
    setSignUpId,
    clearState,
} = signUpSlice.actions;

export const { 
    activeStepSelector,
    userInfoSelector,
} = signUpSlice.selectors;

export default signUpSlice.reducer;